import { registerField, change } from "redux-form";
import _ from "lodash";

export function registerExtraFields(fields, values, defaultValues, dispatch) {
    fields.forEach((element) => {
      dispatch(registerField("editorForm", element, "text"));
      const value = _.get(values, element, _.get(defaultValues, element, null));
      dispatch(change("editorForm", element, value));
    });
  }